import { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

const zingers = [
  {
    key: 1,
    content: (
      <>
        <strong>Domain → Skill → Subskill → Microskill:</strong><br />
        Mastery starts by breaking knowledge into its true structure.
      </>
    )
  },
  {
    key: 2,
    content: (
      <>
        <strong>Example:</strong><br />
        Electrical Engineering → Signal Processing → Fourier Analysis → Rectangular Pulse Transform
      </>
    )
  },
  {
    key: 3,
    content: (
      <>
        <strong>Microskill Example:</strong><br />
        Compute the Fourier transform of a rectangular pulse
      </>
    )
  },
  {
    key: 4,
    content: (
      <>
        <strong>Example:</strong><br />
        Finance → Regulatory Capital → Basel II → Tier 1 Capital Ratio Calculation
      </>
    )
  },
  {
    key: 5,
    content: (
      <>
        <strong>Microskill Example:</strong><br />
        Given Tier 1 Capital = $3.5B and Risk-Weighted Assets = $50B,<br />
        compute the Tier 1 capital ratio.
      </>
    )
  },
  {
    key: 6,
    content: (
      <>
        <strong>Learn by Doing:</strong><br />
        Generate, answer, and learn from microskill questions—build fluency through reps.
      </>
    )
  },
  {
    key: 7,
    content: (
      <>
        <strong>Bottom-Up Mastery:</strong><br />
        Build domain knowledge from the bottom up—one microskill at a time.
      </>
    )
  }
]

export default function ZingerBottom() {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % zingers.length)
    }, 4000)
    return () => clearInterval(interval)
  }, [])

  return (
    <section className="bg-indigo-50 py-10 px-6 rounded-2xl shadow-sm">
      <div className="max-w-lg mx-auto text-center min-h-[140px] flex items-center justify-center">
        <AnimatePresence mode="wait">
          <motion.div
            key={zingers[index].key}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5 }}
            className="text-xl md:text-2xl font-medium text-gray-800"
          >
            {zingers[index].content}
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  )
}
